//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      keyWord: null
    };
  },
  mounted: function mounted() {},
  methods: {
    // 控制按钮显示
    controlBtnShow: function controlBtnShow(status) {},
    // 点击查询
    handleSearch: function handleSearch() {
      this.Bus.emit('onSearch', this.keyWord);
    },
    // 点击新增
    handelAddBtn: function handelAddBtn() {
      this.Bus.emit('onAdd');
    }
  }
};